module.exports = __webpack_public_path__ + "img/icon_emoji.c0e6d67a.svg";